import {
  GET_TECH_DOC_BEGIN,
  GET_TECH_DOC_SUCCESS,
  GET_TECH_DOC_FAILURE,
  GET_MODEL_LIST_SUCCESS,
  RESET_TECH_DOC,
  DOC_PATH,
  DOC_CONFIG_FOLDER,
  DOC_FETCH_MODE,
} from '../constants';
import { getModelListFolders, getTechDocFolderName } from '../config/productsConfig';

const getModelListSuccess = (payload, pageName) => ({
  type: GET_MODEL_LIST_SUCCESS,
  payload,
  pageName,
});

const getTechDocSuccess = (payload, pageName, model = '') => ({
  type: GET_TECH_DOC_SUCCESS,
  payload,
  pageName,
  model,
});

const getTechDocBegin = () => ({
  type: GET_TECH_DOC_BEGIN,
});

const getTechDocFailure = e => ({
  type: GET_TECH_DOC_FAILURE,
  payload: e,
});

const resetTechDoc = () => ({
  type: RESET_TECH_DOC,
});

export const getArrayModelListAction = async function (productName, dispatch) {
  dispatch(getTechDocBegin());
  let docFolderNames = getModelListFolders(productName);
  // try {
  let modelListObj = {};
  for (const docFolderNameObj of docFolderNames) {
    const { folderName, productId } = docFolderNameObj;
    let modelListFilePath = `${DOC_PATH}${folderName}/config/modelList.json`;
    let modelListJson = await fetch(modelListFilePath, DOC_FETCH_MODE);
    let mListObj = await modelListJson.json();
    for (let key in mListObj) {
      mListObj[key] = {
        configFileName: mListObj[key],
        productId,
      };
    }
    modelListObj = { ...modelListObj, ...mListObj };
  }
  await dispatch(getModelListSuccess(modelListObj, 'modelList'));
  // } catch (e) {
  // console.log('>>>>>>>>Error:getArrayModelListAction: ', e);
  // dispatch(getTechDocFailure(e));
  // }
};

export const getTechDocAction = async function (params) {
  const { pageName, dispatch, pageOpt, model } = params;
  let { modelDocConfig, productName } = params;
  if (typeof modelDocConfig === 'object') {
    productName = modelDocConfig.productId;
    modelDocConfig = modelDocConfig.configFileName;
  }

  dispatch(getTechDocBegin());
  const docFolderObj = getTechDocFolderName(productName);
  const docFolderName = docFolderObj.folderName;
  try {
    const docFilePath = `${DOC_PATH}${docFolderName}/`;
    const configFilePath = `${docFilePath}${DOC_CONFIG_FOLDER}`;
    const docsConfigJson = await fetch(configFilePath + modelDocConfig, DOC_FETCH_MODE);
    const docsConfig = await docsConfigJson.json();
    const docFileKey = pageOpt ? `${pageName}-${pageOpt}` : pageName;
    const docFileName = docsConfig[docFileKey] ? docsConfig[docFileKey] : docsConfig[pageName];
    const pageDocContent = await fetch(docFilePath + docFileName, DOC_FETCH_MODE);
    const pageDocContentText = await pageDocContent.text();
    await dispatch(getTechDocSuccess(pageDocContentText, pageName, model));
  } catch (e) {
    dispatch(getTechDocFailure(e));
  }
};

export const resetTechDocAction = function (dispatch) {
  dispatch(resetTechDoc());
};
